import { Card, Placeholder, Table } from 'react-bootstrap';

export const TablePlaceholder = () => {
  return (
    <Table>
      <Card style={{ width: '100%' }} className="overflow-hidden">
        <Card.Body>
          <Placeholder as={Card.Title} animation="glow" className="mb-2">
            <Placeholder xs={12} />
          </Placeholder>
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{
              display: 'flex',
              gap: '1rem',
              overflow: 'hidden',
              justifyContent: 'space-between'
            }}
          >
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
          </Placeholder>
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{
              display: 'flex',
              gap: '1rem',
              overflow: 'hidden',
              justifyContent: 'space-between'
            }}
          >
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
          </Placeholder>{' '}
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{
              display: 'flex',
              gap: '1rem',
              overflow: 'hidden',
              justifyContent: 'space-between'
            }}
          >
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
          </Placeholder>{' '}
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{
              display: 'flex',
              gap: '1rem',
              overflow: 'hidden',
              justifyContent: 'space-between'
            }}
          >
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
          </Placeholder>{' '}
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{
              display: 'flex',
              gap: '1rem',
              overflow: 'hidden',
              justifyContent: 'space-between'
            }}
          >
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
          </Placeholder>{' '}
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{
              display: 'flex',
              gap: '1rem',
              overflow: 'hidden',
              justifyContent: 'space-between'
            }}
          >
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
            <Placeholder xs={3} />
          </Placeholder>
        </Card.Body>
      </Card>
    </Table>
  );
};
